<template>
  <v-list-item v-ripple @click="$emit('click')">
    <v-list-item-content class="config-list-item">
      <v-list-item-title>
        <div class="config-list-row">
          <span>{{ label }}</span>
          <slot>
            <span>{{ value }}</span>
          </slot>
        </div>
      </v-list-item-title>
      <v-list-item-subtitle v-if="showSubtitle">
        {{ date | moment('DD/MM/YYYY HH:mm') }}
        por
        <code>{{ login }}</code>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    label: { required: true },
    value: {},
    date: {},
    login: {}
  },
  computed: {
    showSubtitle() {
      return this.date != null || this.login != null
    }
  }
}
</script>

<style lang="sass">
.config-list-row
  display: flex
  flex-flow: row nowrap
  justify-content: space-between

</style>
